import { c as _c } from "react/compiler-runtime";
import { IcoRepeat40, IcoWarning16 } from '@onefootprint/icons';
import { NavigationHeader } from '@onefootprint/idv2';
import { useTranslation } from 'react-i18next';
import { useTimeout } from 'usehooks-ts';
import { TRANSITION_DELAY_LONG } from '../../constants';
import FadeInContainer from '../fade-in-container';
import FeedbackIcon from '../feedback-icon';
type RetryLimitExceededProps = {
  onRetryLimitExceeded: () => void;
};
const RetryLimitExceeded = t0 => {
  const $ = _c(16);
  const {
    onRetryLimitExceeded
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.retry-limit-exceeded"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  let t2;
  if ($[1] !== onRetryLimitExceeded) {
    t2 = () => {
      onRetryLimitExceeded();
    };
    $[1] = onRetryLimitExceeded;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useTimeout(t2, TRANSITION_DELAY_LONG);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <NavigationHeader />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FeedbackIcon imageIcon={{
      component: IcoRepeat40
    }} statusIndicator={{
      component: <IcoWarning16 color="error" />,
      status: "error"
    }} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="text-label-1 text-error text-center">{t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t(_temp2);
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <div className="text-body-2 text-secondary text-center">{t7}</div>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <FadeInContainer><div className="flex flex-col justify-center items-center gap-4">{t3}{t4}<div className="flex flex-col justify-center items-center gap-2">{t6}{t8}</div></div></FadeInContainer>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default RetryLimitExceeded;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.description;
}